// import { getCookie, setCookie, removeCookie } from '@comm/utils/cookieUtils'
import { getLocalStorage, setLocalStorage, removeLocalStorage } from "@/utils/localStorageUtils"

const TokenKey = 'bpmtoken'

export function getToken() {
  return getLocalStorage(TokenKey)
}

export function setToken(token) {
  return setLocalStorage(TokenKey, token)
}

export function removeToken() {
  return removeLocalStorage(TokenKey)
}
